import { render, staticRenderFns } from "./JobDescription.htm?vue&type=template&id=3be5a40f&scoped=true&"
import script from "./JobDescription.ts?vue&type=script&lang=js&"
export * from "./JobDescription.ts?vue&type=script&lang=js&"
import style0 from "./JobDescription.scss?vue&type=style&index=0&id=3be5a40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be5a40f",
  null
  
)

export default component.exports